import Position from "./Position"
class TransformUtil {

    //转经纬度
    static transformCartesianToWGS84(cartesian) {
        if (cartesian) {
            let cartographic = Cesium.Ellipsoid.WGS84.cartesianToCartographic(
                cartesian
            )
            return new Position(
                Cesium.Math.toDegrees(cartographic?.longitude || 0),
                Cesium.Math.toDegrees(cartographic?.latitude || 0),
                cartographic.height || 0
            )
        }
        return new Position(0, 0)
    }
}

export default TransformUtil;